import React from 'react';

const sides = [
  { name: 'Mango', price: '$6' },
  { name: 'Beans', price: '$5' },
  { name: 'Rice', price: '$5' },
  { name: 'Avocado — MP (Market Price)', price: '' },
  { name: 'Tostadas (4 pcs)', price: '$4' },
  { name: 'Special Mayo', price: '$3' },
];

const prawnBorder =
  'https://santaplaya-bucket.s3.amazonaws.com/prawn_border.webp';

const SidesSection: React.FC = () => {
  return (
    <section className="relative bg-white py-12 px-4 lg:px-24">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-charles text-maroon text-4xl md:text-6xl mb-8">
          SIDES
        </h2>
        <ul className="space-y-4 mb-36">
          {sides.map((side, idx) => (
            <li key={idx} className="font-prosto text-sea text-xl">
              <div className="flex flex-col items-center justify-center">
                <span>{side.name}</span>
                {side.price && (
                  <span className="font-bold mt-1">{side.price}</span>
                )}
              </div>
            </li>
          ))}
        </ul>
        <img src={prawnBorder} className="w-full mb-24" />
      </div>
      {/* Accent Images (absolutely positioned) */}
      {/* Blue Bubbles at bottom left */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp"
        alt="Blue Bubbles"
        className="pointer-events-none absolute bottom-48 left-[15%] w-[8vw] opacity-80"
      />
      {/* Blue Bubbles at top right */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/bubbles_blue.webp"
        alt="Blue Bubbles"
        className="pointer-events-none absolute top-0 right-[20%] w-[8vw] opacity-80"
      />
      {/* Blue Prawn at top left */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/blue_prawn.webp"
        alt="Blue Prawn"
        className="pointer-events-none transform rotate-[140deg] absolute top-[6.25%] left-[12.5%] w-[15vw] opacity-90"
      />
      {/* Lobster with Drink at bottom right */}
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/lobster_with_drink.webp"
        alt="Lobster with Drink"
        className="pointer-events-none absolute bottom-48 right-0 w-[40vw] opacity-90"
      />
    </section>
  );
};

export default SidesSection;
